export default "__VITE_ASSET__88697ccb__"